import { css } from "lit";

export const styles = css`
  .streaming-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    height: 100%;
    min-height: 0;
  }

  .streaming-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .duration {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    font-variant-numeric: tabular-nums;
  }

  .video-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--sds-color-background-default-tertiary);
    border-radius: var(--sds-border-radius-03);
    overflow: hidden;
    min-height: 0;
  }

  .video-container stream-recorder {
    width: 100%;
    height: 100%;
  }

  .streaming-controls {
    display: flex;
    gap: 12px;
    justify-content: center;
    padding-top: 8px;
  }

  .error-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: var(--sds-color-background-danger-subtle);
    color: var(--sds-color-text-danger-default);
    border-radius: var(--sds-border-radius-03);
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
  }

  .preview-info-banner {
    display: flex;
    gap: var(--sds-size-space-300);
    padding: var(--sds-size-space-400);
    background: var(--sds-color-background-default-default);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
  }

  .preview-info-banner ph-info {
    flex-shrink: 0;
    color: var(--sds-color-icon-brand-default);
  }

  .preview-info-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
  }

  .preview-info-content p {
    margin: 0;
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-regular);
    color: var(--sds-color-text-default-default);
    line-height: var(--sds-typography-body-line-height-medium);
  }

  .preview-info-content p:first-child {
    font-weight: var(--sds-typography-weight-medium);
  }

  .preview-info-content ul {
    margin: 0;
    margin-left: var(--sds-size-space-600);
    padding-left: var(--sds-size-space-500);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-default-default);
    line-height: var(--sds-typography-body-line-height-medium);
  }

  .preview-info-content li {
    margin: var(--sds-size-space-100) 0;
  }

  .connecting-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 40px;
    color: var(--sds-color-text-default-secondary);
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
  }

  .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid var(--sds-color-border-default-default);
    border-top-color: var(--sds-color-border-brand-default);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    .streaming-content {
      padding: 8px;
      gap: 12px;
    }

    .video-container {
      border-radius: 0;
      margin: 0 -8px;
      width: calc(100% + 16px);
    }

    .streaming-controls {
      flex-direction: column;
      padding: 0 8px;
    }

    .streaming-controls wow-button {
      width: 100%;
    }
  }

  .confirmation-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
  }

  .confirmation-content p {
    margin: 0;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }

  .confirmation-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;
